import React from 'react';

import PrimaryButton from '../../../components/Buttons/PrimaryButton';
import PresentationTimer from './PresentationTimer';
import {
  clampScore,
  CRITERIA,
  MAX_TOTAL,
  totalScore,
  TPresentationScores,
} from './presentationRules';
import {
  Criterion,
  Footer,
  Max,
  Note,
  Panel,
  PanelTitle,
  ScoreBox,
  ScoreControl,
  Total,
} from './styles';

interface IPresentationFormProps {
  teamId: string;
  teamName: string;
  subtitle: string;
  scores: TPresentationScores;
  alreadyScored: boolean;
  saving: boolean;
  onChange: (scores: TPresentationScores) => void;
  onSave: () => void;
}

/** Formulário de um time: os quatro critérios do item 4.2.5 e o total ao vivo. */
const PresentationForm: React.FC<IPresentationFormProps> = ({
  teamId,
  teamName,
  subtitle,
  scores,
  alreadyScored,
  saving,
  onChange,
  onSave,
}) => {
  const total = totalScore(scores);

  return (
    <Panel aria-labelledby="presentation-team">
      <PanelTitle>
        <h2 id="presentation-team">{teamName}</h2>
        <p>{subtitle}</p>
      </PanelTitle>

      <PresentationTimer resetKey={teamId} />

      {CRITERIA.map(criterion => {
        const value = scores[criterion.key];
        const set = (raw: number) =>
          onChange({
            ...scores,
            [criterion.key]: clampScore(criterion.key, raw),
          });

        return (
          <Criterion key={criterion.key}>
            <h3 id={`${criterion.key}-label`}>{criterion.label}</h3>
            <Max>até {criterion.max} pts</Max>
            <ul>
              {criterion.questions.map(question => (
                <li key={question}>{question}</li>
              ))}
            </ul>
            <ScoreControl>
              <input
                type="range"
                min={0}
                max={criterion.max}
                step={1}
                value={value}
                aria-labelledby={`${criterion.key}-label`}
                aria-valuetext={`${value} de ${criterion.max} pontos`}
                onChange={e => set(Number(e.target.value))}
                disabled={saving}
              />
              <ScoreBox
                type="text"
                inputMode="numeric"
                aria-label={`${criterion.label}: pontos`}
                value={value}
                onChange={e => set(Number(e.target.value.replace(/\D/g, '')))}
                onFocus={e => e.target.select()}
                disabled={saving}
              />
            </ScoreControl>
          </Criterion>
        );
      })}

      <Footer>
        <Total aria-live="polite">
          <strong>{total}</strong>de {MAX_TOTAL} pontos
        </Total>
        <PrimaryButton
          type="button"
          onClick={onSave}
          loading={saving}
          disabled={saving}
        >
          {alreadyScored ? 'Atualizar avaliação' : 'Salvar avaliação'}
        </PrimaryButton>
      </Footer>
      <Note>
        A nota soma-se aos pontos de arena na classificação da etapa nacional.
        Professores tutores não podem estar na sala durante a apresentação.
      </Note>
    </Panel>
  );
};

export default PresentationForm;
